import { createI18n } from 'vue-i18n'

export const supportedLocales = ['es', 'en', 'pt', 'fr']

const storedLocale = typeof window !== 'undefined' ? localStorage.getItem('appLanguage') : null
const defaultLocale = storedLocale && supportedLocales.includes(storedLocale) ? storedLocale : 'es'

const i18n = createI18n({
  legacy: false,
  messages: {},
  locale: defaultLocale,
  fallbackLocale: 'es',
  globalInjection: true
})

export const syncDocumentLang = (locale: string) => {
  document.documentElement.lang = locale
}

// Cargar mensajes de forma dinámica
export const loadLocaleMessages = async (locale: string) => {
  const messages = await import(`../locales/${locale}.json`)
  const documentation = await import(`../locales/documentation/${locale}.json`)
  i18n.global.setLocaleMessage(locale, {
    ...messages.default,
    documentation: documentation.default
  })
}

// Cargar el idioma por defecto
loadLocaleMessages(defaultLocale)

export default i18n
